import Responsive from '../lib/responsive';
import Swiper from '../custom/swiper';
import axios from 'axios';
import {toArray} from 'lodash';
import LazyLoadingImage from './LazyLoadingImage';
import AddTo from './AddTo';
import Tabs from './Tabs';

export default class Quickview {

  constructor(element) {
    if (!element) {
      return;
    }

    this.el = element;
    this.quickviewOpenListener = toArray(this.el.querySelectorAll('.tc-quickview-button'));
    this.quickviewElementId = this.el.getAttribute('data-quickview-id') || 'quickview-overlay';
    this.quickviewElement = document.getElementById(this.quickviewElementId);
    this.videoTab = null;
    if (!this.quickviewElement) {

      return;
    }

    this.swiperContainer = this.quickviewElement.querySelector('.swiper-container');
    this.nextBtn = this.quickviewElement.querySelector('.swiper-button-next');
    this.prevBtn = this.quickviewElement.querySelector('.swiper-button-prev');
    const setupMoviesHandler = this.setupMovies.bind(this);
    const loadQuickviewSlideHandler = this.handleLoad.bind(this);
    this.swiperContent = {};

    this.swiperOptions = {
      loop: false,
      spaceBetween: 20,
      threshold: 20,
      paginationClickable: true,
      simulateTouch: true,
      slidesPerView: 1,
      nextButton: this.nextBtn,
      prevButton: this.prevBtn,
      effect: 'slide',
      onInit(swiper) {

        setupMoviesHandler(swiper);
      },
      onSlideChangeStart(swiper) {

        loadQuickviewSlideHandler(swiper.activeIndex);
      }
    };

    this.swiper = new Swiper(this.swiperContainer, this.swiperOptions);

    this.registerEvents();
  }

  setupMovies(swiper) {

    swiper.removeAllSlides();
    for (let i = 0; i < this.quickviewOpenListener.length; i++) {

      const movBtn = this.quickviewOpenListener[i];
      const movieId = movBtn.getAttribute('data-movie-id');

      if (!movieId) {

        movBtn.style.display = 'none';
      }

      swiper.appendSlide(`<div class="swiper-slide" data-offset="${i}"></div>`);

      this.swiperContent[i] = {

        loaded: false,
        initialized: false,
        markup: false,
        movieId
      };

      movBtn.movieId = movieId;
    }
  }

  registerEvents() {

    window.addEventListener('resize', this.handleResizes.bind(this), false);

    const event = '#' + this.quickviewElementId;

    document.addEventListener(`quickview-open${event}`, this.handleOpen.bind(this), false);
    document.addEventListener(`quickview-close${event}`, this.handleClose.bind(this), false);
    document.addEventListener(`quickview-tab-change${event}`, this.handleTabChange.bind(this), false);

    this.quickviewOpenListener.forEach((element, index) => {
      element.addEventListener('click', this.handleLoad.bind(this, index), false);
    });
  }

  handleLoad(index) {

    if (this.swiperContent[index].loaded) {

      if (this.swiper.activeIndex !== index) {

        this.swiper.slideTo(index, 0);
      }


      this.play(index);

      return;
    }

    window.tcLoader.setActive(true);
    if (this.swiper.activeIndex !== index) {

      this.swiper.slideTo(index, 0);
    }
    axios.get(window.routes.getQuickviewElement[0], {
      params: {
        'movie_id': this.swiperContent[index].movieId
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(res => {

        window.tcLoader.setInactive(true);

        this.swiperContent[index].markup = res.data.movie;
        this.swiperContent[index].slideWrapper = this.swiperContainer.querySelector(`[data-offset="${index}"]`);
        this.swiperContent[index].slideWrapper.innerHTML = this.swiperContent[index].markup;

        window.taikoComponent.reloadModule(LazyLoadingImage, '.tc-lazy-loading-image');
        window.taikoComponent.reloadModule(Tabs, '.tc-tabs');
        window.taikoComponent.reloadModule(AddTo, '.tc-add-to');
        window.responsiveImagesManager.setup(this.swiperContent[index].slideWrapper);

        this.swiperContent[index].loaded = true;
        this.swiper.update();
        this.handleResizes();
      })
      .catch(error => {

        window.tcLoader.setInactive(true);
        window.console.log(`can't get movie-informations: ${error.message}`);

        throw `Quickview.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
      });
  }

  handleTabChange(e) {

    if (e.preventDefault) {

      e.preventDefault();
    }

    const slideWrapper = this.swiperContent[this.swiper.activeIndex].slideWrapper;
    this.videoTab = slideWrapper ?
        slideWrapper.querySelector('.is-video-tab') || null :
        null;

  }

  handleResizes() {

    this.handleWidths();
    this.handleHeights();
  }

  handleHeights() {

    const bp = Responsive.getBreakpoint();

    if (bp === ('s' || 'xs')) {

      return;
    }

    const heightWrappers = toArray(this.quickviewElement.querySelectorAll('.quickview-tap-wrapper .content'));
    const length = heightWrappers.length;

    this.swiperContainer.style.height = '';

    for (let i = 0; i < length; i++) {

      heightWrappers[i].style.height = '';
    }

    const containerHeight = this.swiperContainer.offsetHeight;
    const targetHeight = window.innerHeight - 100;

    if (containerHeight > targetHeight && length) {

      const wrapperHeight = heightWrappers[0].offsetHeight;
      const diff = containerHeight - wrapperHeight;

      this.swiperContainer.style.height = `${targetHeight}px`;

      for (let i = 0; i < length; i++) {

        heightWrappers[i].style.height = `${targetHeight - diff}px`;
      }

    } else {

      for (let i = 0; i < length; i++) {

        heightWrappers[i].style.height = '';
      }
    }
  }

  handleWidths() {

    this.quickviewInfoWrapper = toArray(this.quickviewElement.querySelectorAll('.quickview-info-wrapper'));
    this.quickviewInfoWrapper.map(el => {

      if (!el.quickviewInfoLeft) {

        el.quickviewInfoLeft = el.querySelector('.quickview-info-left');
      }

      if (!el.quickviewInfoRight) {

        el.quickviewInfoRight = el.querySelector('.quickview-info-right');
      }

      if (!el.quickviewInfoRight || !el.quickviewInfoLeft) {

        return;
      }

      el.quickviewInfoLeft.style.width = `${el.getBoundingClientRect().width - el.quickviewInfoRight.getBoundingClientRect().width - 1}px`;
    });

    this.swiper.update();
  }

  handleOpen(e) {

    if (e.preventDefault) {

      e.preventDefault();
    }

    this.handleWidths();
    document.addEventListener('keyup', this.handlyKeyControl.bind(this));
  }

  handleClose(e) {

    if (e.preventDefault) {

      e.preventDefault();
    }

    document.removeEventListener('keyup', this.handlyKeyControl.bind(this));
  }

  handlyKeyControl(e) {

    if (e.preventDefault) {

      e.preventDefault();
    }

    // left key or a
    if (e.keyCode === 37 || e.keyCode === 65) {

      this.swiper.slidePrev();

      // right key or d
    } else if (e.keyCode === 39 || e.keyCode === 68) {

      this.swiper.slideNext();
    }
  }
};
